import { User } from 'graphql'
import { userFullName } from '../../utils'

export type UserWithLabel = User & { label: string }

export default function getSortedUsersWithLabel( companyUsers: User[], labelRenderer = userFullName ): UserWithLabel[] {
	return companyUsers.map( ( u ) => ( { ...u, label: labelRenderer( u ) } ) )
		.sort( ( a, b ) => a.label.localeCompare( b.label ) )
}
